import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule } from '@principle-theorem/ng-shared';
import { Recalls } from '@principle-theorem/principle-core';
import { IAppointment } from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  Firestore,
  SHORT_DATE_TIME_FORMAT,
  Timestamp,
  toTimestamp,
  WithRef,
} from '@principle-theorem/shared';
import * as moment from 'moment-timezone';
import { MomentModule } from 'ngx-moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-recall-appointment',
  templateUrl: './recall-appointment.component.html',
  styleUrls: ['./recall-appointment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MomentModule,
    PipesModule,
  ],
})
export class RecallAppointmentComponent {
  dateFormat = SHORT_DATE_TIME_FORMAT;

  label = input<string>('Recall Appointment');
  emptyMessage = input<string>('None');
  appointmentRef = input<DocumentReference<IAppointment> | undefined>();
  recallDate = input<Timestamp | moment.Moment | undefined>();

  isEmpty = computed(() => !this.appointmentRef() && !this.recallDate());
  appointment: Signal<WithRef<IAppointment> | undefined>;

  displayDate: Signal<Timestamp | undefined>;
  timeDistance = computed<string | undefined>(() =>
    Recalls.getTimeDistance(this.displayDate())
  );

  constructor() {
    const appointment$ = toObservable(this.appointmentRef).pipe(
      switchMap((ref) => (ref ? Firestore.getDoc(ref) : of(undefined)))
    );
    this.appointment = toSignal(appointment$, { initialValue: undefined });
    this.displayDate = computed(() => {
      const recallDate = this.recallDate();
      return recallDate
        ? toTimestamp(recallDate)
        : this.appointment()?.event?.from;
    });
  }
}
